import { Avatar, AvatarFallback, AvatarImage } from "@/ui/avatar";
import { cn } from "@/utils";
import { getInitials } from "@/utils/avatar";

interface UserAvatarProps {
	avatar?: string;
	username?: string;
	size?: "sm" | "md" | "lg" | "xl";
	className?: string;
}

export function UserAvatar({ avatar, username, size = "md", className }: UserAvatarProps) {
	const sizeClasses = {
		sm: "h-6 w-6",
		md: "h-8 w-8",
		lg: "h-10 w-10",
		xl: "h-16 w-16",
	};

	const textSizes = {
		sm: "text-xs",
		md: "text-sm",
		lg: "text-base",
		xl: "text-lg",
	};

	return (
		<Avatar className={cn(sizeClasses[size], className)}>
			<AvatarImage src={avatar} alt={username} />
			<AvatarFallback className={cn("font-medium", textSizes[size])}>{getInitials(username)}</AvatarFallback>
		</Avatar>
	);
}
